import * as immutable from 'immutable';

export function castToType(type, value, forceNewInstance: boolean = false) {
  if (!forceNewInstance && value && value.constructor.name.toLowerCase() === type.toLowerCase()) {
    return value;
  }

  switch (type.toLowerCase()) {
    case CastTypes.MAP:
      return immutable.Map(value);
    case CastTypes.SET:
      return immutable.Set(value);
    case CastTypes.LIST:
      return immutable.List(value);
    case CastTypes.STACK:
      return immutable.Stack(value);
    case CastTypes.PROXY:
      return new Proxy(value, { });
    case CastTypes.OBJECT:
      return value && 'toObject' in value ? value.toObject() : { ...value};
    case CastTypes.ARRAY:
      return value && 'toArray' in value ? value.toArray() : [...value];
    default:
      return value;
  }
}

export enum CastTypes {
  MAP = 'map',
  SET = 'set',
  LIST = 'list',
  STACK = 'stack',
  PROXY = 'proxy',
  OBJECT = 'object',
  ARRAY = 'array'
}
